const createProgram = ({
  name,
  location,
  type,
  sourceUrl,
  overview,
  credential,
  format,
  length,
  tuition,
  admissions,
  focus,
  highlights,
  mapEmbedUrl,
}) => ({
  name,
  location,
  type,
  credential,
  format,
  length,
  tuition,
  admissions,
  summary: overview,
  badge: type,
  websiteUrl: sourceUrl,
  sourceUrl,
  specs: [
    ['Program type', type],
    ['Credential', credential],
    ['Class format', format],
    ['Program length', length],
    ['Tuition and fees', tuition],
    ['Admissions and requirements', admissions],
  ],
  paragraphs: [
    focus,
    'Program length, tuition, prerequisites, clinical requirements, application deadlines, and cohort availability can change. Confirm all current details directly with the institution before applying.',
  ],
  highlights,
  address: location,
  mapEmbedUrl,
});

export const programs = [
  createProgram({
    name: 'Los Angeles Valley College',
    location: '5800 Fulton Avenue, Van Nuys, CA 91401',
    type: 'Public vocational healthcare training pathway',
    sourceUrl: 'https://www.lavc.edu/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Los+Angeles+Valley+College+Van+Nuys+CA&output=embed',
    overview:
      'This career training pathway helps individuals enter the healthcare sphere as a certified physical therapy aide through a focused vocational voucher program.',
    credential: 'Certified physical therapy aide preparation',
    format: 'Flexible vocational modules and practical training options',
    length: 'A few months, depending on selected modules',
    tuition:
      'Costs vary depending on selected modules, materials, and voucher options.',
    admissions:
      'Review current enrollment, voucher eligibility, module requirements, and materials information with Los Angeles Valley College.',
    focus:
      'While not a full CAPTE-accredited PTA degree, this pathway offers a fast, affordable introduction to physical rehabilitation support roles and local job entry.',
    highlights: [
      'Los Angeles-area public college pathway',
      'Focused physical therapy aide preparation',
      'Flexible study options',
      'Not a full CAPTE-accredited PTA degree',
    ],
  }),
  createProgram({
    name: 'Santa Monica College',
    location: '1900 Pico Boulevard, Santa Monica, CA 90405',
    type: 'Vocational physical therapy aide training',
    sourceUrl: 'https://www.smc.edu/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Santa+Monica+College+Santa+Monica+CA&output=embed',
    overview:
      'This vocational track prepares aspiring support professionals for certified physical therapy aide roles through flexible online training modules paired with practical voucher options.',
    credential: 'Certified physical therapy aide preparation',
    format: 'Flexible online modules and practical voucher options',
    length: 'Short-term and self-paced',
    tuition:
      'Accessible material costs vary by selected training modules and voucher options.',
    admissions:
      'Confirm current module availability, enrollment requirements, voucher details, and materials costs with Santa Monica College.',
    focus:
      'The program is a stepping stone for students seeking rapid exposure to outpatient clinics without committing to a multi-year PTA degree immediately.',
    highlights: [
      'West Los Angeles vocational option',
      'Online and self-paced learning format',
      'Practical voucher options may be available',
      'Designed for rapid exposure to outpatient support roles',
    ],
  }),
  createProgram({
    name: 'Glendale Community College',
    location: '1500 North Verdugo Road, Glendale, CA 91208',
    type: 'Community college health science and vocational pathway',
    sourceUrl: 'https://www.glendale.edu/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Glendale+Community+College+Glendale+CA&output=embed',
    overview:
      'Located at the specialized Montrose campus, this regional site extends educational and community training services supporting health science pathways.',
    credential: 'Health science and vocational training preparation',
    format:
      'Community college coursework, vocational services, and structured guidance',
    length: 'Varies by selected pathway',
    tuition:
      'Fees align with standard California community college tuition structures, alongside nominal material costs.',
    admissions:
      'Review current campus services, pathway availability, prerequisites, and enrollment requirements with Glendale Community College.',
    focus:
      'Glendale Community College provides local students with accessible community resources, dedicated vocational focus, and structured guidance toward allied health careers.',
    highlights: [
      'Montrose-area regional training access',
      'Community college tuition structure',
      'Health science and allied health support',
      'Structured local career guidance',
    ],
  }),
  createProgram({
    name: 'Cerritos College',
    location: '11110 Alondra Boulevard, Norwalk, CA 90650',
    type: 'Public CAPTE-accredited PTA degree program',
    sourceUrl: 'https://www.cerritos.edu/pt/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Cerritos+College+Norwalk+CA&output=embed',
    overview:
      'Cerritos College offers a respected, CAPTE-accredited Associate of Science program combining intensive evening classroom instruction with daytime clinical rotations.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'Evening classroom instruction, laboratory practice, and daytime clinical rotations',
    length: '4 semesters',
    tuition:
      'Approximately $4,650 in-state tuition and institutional fees, excluding books and supplies.',
    admissions:
      'Prerequisites in anatomy and physiology are required before entry. Confirm current application, prerequisite, and health-compliance requirements.',
    focus:
      'The program provides a cost-effective public route to full PTA licensure for dedicated students prepared for evening coursework and daytime clinical education.',
    highlights: [
      'CAPTE-accredited PTA program',
      'Associate of Science degree',
      'Four-semester sequence',
      'Approximately $4,650 before books and supplies',
    ],
  }),
  createProgram({
    name: 'College of the Canyons',
    location: '26455 Rockwell Canyon Road, Santa Clarita, CA 91355',
    type: 'Public CAPTE-candidate PTA degree program',
    sourceUrl: 'https://www.canyons.edu/academics/pta/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=College+of+the+Canyons+Santa+Clarita+CA&output=embed',
    overview:
      'College of the Canyons offers a comprehensive Associate degree pathway that combines modern on-campus laboratory simulations with hands-on clinical education.',
    credential: 'Associate degree in Physical Therapist Assistant studies',
    format:
      'On-campus laboratory simulations and supervised clinical education',
    length: '5 semesters',
    tuition:
      'Estimated in-state district tuition is approximately $3,795 for the technical phase, excluding books, supplies, and other required expenses.',
    admissions:
      'Confirm current candidate status, prerequisites, application deadlines, clinical requirements, and health-compliance documentation.',
    focus:
      'The program is structured to build clinical decision-making and patient-care competencies for high-demand healthcare markets throughout Southern California.',
    highlights: [
      'CAPTE-candidate Associate degree pathway',
      'Five-semester structure',
      'Modern on-campus lab simulations',
      'Approximately $3,795 technical-phase district tuition',
    ],
  }),
  createProgram({
    name: 'CBD College',
    location: '3699 Wilshire Boulevard, Los Angeles, CA 90010',
    type: 'Private CAPTE-accredited PTA program',
    sourceUrl: 'https://www.cbd.edu/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=CBD+College+Los+Angeles+CA&output=embed',
    overview:
      'CBD College offers a private, CAPTE-accredited Associate of Applied Science pathway delivered through an intensive, fast-paced study track.',
    credential: 'Associate of Applied Science in Physical Therapist Assistant',
    format:
      'Classroom instruction, laboratory immersion, and clinical internships',
    length: 'Accelerated intensive study track',
    tuition:
      'Approximately $49,923 in technical program tuition and institutional costs, plus books and additional fees.',
    admissions:
      'Review current prerequisites, application requirements, compliance documentation, and financial aid options with CBD College.',
    focus:
      'The program emphasizes hands-on laboratory immersion and dedicated clinical internships to prepare graduates for the national licensure examination.',
    highlights: [
      'CAPTE-accredited private program',
      'Associate of Applied Science degree',
      'Fast-paced instructional model',
      'Approximately $49,923 before additional books and fees',
    ],
  }),
  createProgram({
    name: 'Casa Loma College',
    location: '6720 Kester Avenue, Van Nuys, CA 91411',
    type: 'Private CAPTE-accredited PTA program',
    sourceUrl: 'https://www.casaloma.edu/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Casa+Loma+College+Van+Nuys+CA&output=embed',
    overview:
      'Casa Loma College operates a CAPTE-accredited Associate of Science PTA program blending foundational medical sciences with extensive clinical practice.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'Medical science coursework, laboratory instruction, and clinical practice',
    length: 'Program length varies by current academic schedule',
    tuition:
      'Approximately $52,749 including estimated tuition, fees, and books.',
    admissions:
      'Confirm current prerequisites, admission steps, health requirements, background checks, and clinical placement policies.',
    focus:
      'The program emphasizes personalized student support and practical readiness for professional healthcare settings.',
    highlights: [
      'CAPTE-accredited Associate of Science program',
      'Medical science and clinical practice integration',
      'Personalized student support',
      'Approximately $52,749 including estimated books and fees',
    ],
  }),
  createProgram({
    name: 'Stanbridge University',
    location: '2041 Business Center Drive, Irvine, CA 92612',
    type: 'Private CAPTE-accredited PTA program',
    sourceUrl:
      'https://www.stanbridge.edu/programs/physical-therapist-assistant/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Stanbridge+University+Irvine+CA&output=embed',
    overview:
      'Stanbridge University features a technology-forward Associate of Science in Physical Therapist Assistant program with intensive lab environments and comprehensive clinical placements.',
    credential: 'Associate of Science in Physical Therapist Assistant',
    format:
      'Technology-supported coursework, intensive laboratories, and clinical placements',
    length: 'Approximately 18 to 24 months',
    tuition:
      'Private institutional tuition rates apply. Confirm current tuition, fees, books, financial aid, and payment options with Stanbridge University.',
    admissions:
      'Review current prerequisites, admissions testing, health documentation, background checks, and clinical placement requirements.',
    focus:
      'The curriculum integrates modern learning tools, advanced lab environments, clinical education, and board examination preparation resources.',
    highlights: [
      'CAPTE-accredited Associate of Science program',
      'Technology-forward learning environment',
      'Approximately 18 to 24 months',
      'Comprehensive clinical placement and board preparation support',
    ],
  }),
  createProgram({
    name: 'Concorde Career College (North Hollywood)',
    location: '1231 North Pacific Avenue, Glendale, CA 91202',
    type: 'Private accelerated PTA program',
    sourceUrl:
      'https://www.concorde.edu/programs/physical-therapist-assistant/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Concorde+Career+College+North+Hollywood+CA&output=embed',
    overview:
      'Concorde Career College provides an accelerated Associate of Applied Science path designed to move students into the physical therapy workforce quickly.',
    credential: 'Associate of Applied Science in Physical Therapist Assistant',
    format:
      'Classroom lectures, practical laboratory training, and clinical rotations',
    length: 'Accelerated timeline; confirm the current sequence with the campus',
    tuition:
      'Private tuition rates apply and typically include comprehensive career services and academic support. Confirm the current total cost directly with the campus.',
    admissions:
      'Review current prerequisites, application requirements, compliance documentation, and financial aid options with the North Hollywood-area campus.',
    focus:
      'The blended model combines lectures, practical skill development, and real-world clinical rotations as a direct route toward licensure preparation.',
    highlights: [
      'Accelerated Associate of Applied Science pathway',
      'Classroom, laboratory, and clinical instruction',
      'Career services and academic support',
      'Private tuition and fees apply',
    ],
  }),
  createProgram({
    name: 'Concorde Career College (Garden Grove)',
    location: '12951 Euclid Street, Garden Grove, CA 92840',
    type: 'Private CAPTE-accredited PTA program',
    sourceUrl:
      'https://www.concorde.edu/programs/physical-therapist-assistant/',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Concorde+Career+College+Garden+Grove+CA&output=embed',
    overview:
      'Concorde’s Garden Grove campus offers a CAPTE-accredited Associate degree track with structured pacing and hands-on clinical immersion.',
    credential: 'Associate degree in Physical Therapist Assistant studies',
    format:
      'Classroom instruction, laboratory practice, and clinical immersion',
    length: 'Accelerated timeline; verify the current program sequence',
    tuition:
      'Total expenses include private tuition, specialized uniform and laboratory fees, and textbooks.',
    admissions:
      'Confirm current prerequisites, application deadlines, clinical compliance, background checks, and health documentation.',
    focus:
      'The curriculum covers kinesiology, therapeutic exercise, and modalities while preparing students for rapid professional deployment.',
    highlights: [
      'CAPTE-accredited Associate degree track',
      'Garden Grove campus serving Orange County',
      'Structured accelerated pacing',
      'Hands-on clinical immersion',
    ],
  }),
  createProgram({
    name: 'Loma Linda University',
    location: '11092 Anderson Street, Loma Linda, CA 92350',
    type: 'Private health sciences PTA program',
    sourceUrl:
      'https://alliedhealth.llu.edu/physical-therapist-assistant',
    mapEmbedUrl:
      'https://www.google.com/maps?q=Loma+Linda+University+Loma+Linda+CA&output=embed',
    overview:
      'Loma Linda University offers a rigorous PTA curriculum grounded in whole-person care, advanced clinical training, and health sciences education.',
    credential: 'Physical Therapist Assistant degree or certificate pathway',
    format:
      'Health sciences coursework, advanced laboratory training, and clinical education',
    length: 'Varies by current curriculum and enrollment schedule',
    tuition:
      'Private health-science tuition rates apply. Confirm current tuition, fees, books, financial aid, and payment options with Loma Linda University.',
    admissions:
      'Review current prerequisites, application materials, observation requirements, health documentation, and clinical placement policies.',
    focus:
      'The program supports professional readiness through regional medical facility placements, comprehensive resources, and preparation for the national board examination.',
    highlights: [
      'Top-tier Southern California health sciences institution',
      'Whole-person care emphasis',
      'Advanced clinical training',
      'Financial aid and comprehensive student resources',
    ],
  }),
];

export const resources = [
  {
    title: 'American Physical Therapy Association',
    description:
      'Explore physical therapy education, professional standards, advocacy, and career resources.',
    url: 'https://www.apta.org/',
  },
  {
    title: 'Federation of State Boards of Physical Therapy',
    description:
      'Review physical therapist assistant licensure and National Physical Therapy Examination resources.',
    url: 'https://www.fsbpt.org/',
  },
  {
    title: 'California Physical Therapy Board',
    description:
      'Find California licensing, renewal, rules, and practice information for PTAs.',
    url: 'https://www.ptbc.ca.gov/',
  },
];